import { API } from '@/http-common.js';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useFormateurStore = defineStore('formateur', () => {
    const profile = ref(null);
    const contratsASignerCount = ref(0);

    async function fetchFormateurProfile() {
        const response = await API.get('formateur/profile');
        if (response?.data) {
            profile.value = response.data;
            if (response.data.contrats && response.data.hasAcceptedRgpd) {
                fetchContratsASignerCount();
            }
        }

        return profile.value;
    }
    async function acceptRgpd() {
        await API.post('formateur/accept-rgpd');
    }

    async function fetchContratsASignerCount() {
        const response = await API.get('formateur/contrats/count');
        if (response?.data) {
            contratsASignerCount.value = response.data;
        }
        return contratsASignerCount.value;
    }
    return {
        profile,
        contratsASignerCount,
        fetchFormateurProfile,
        acceptRgpd,
        fetchContratsASignerCount
    };
});
